<template>
  <main :style="{'--dominant': '#FFF5C1', '--average': '#FFD400',}"
    class="project-gradient min-h-screen flex md:flex-col flex-row"
    v-if="projects"
    v-infinite-scroll="loadMore"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
  >
      <div class="fixed top-20 leading-tight lg:top-12 right-0 z-50 py-0 px-4 lg:px-8 text-base md:text-lg flex flex-col md:flex-row items-end space-x-8">
            <div aria-label="filter projects by editorial" role="button" tabindex="0" @click="changeFilter('editorial')" @keydown.enter.self="changeFilter('editorial')" :class="{'underline': filter == 'editorial'}" class="cursor-pointer">Editorial</div>
            <div aria-label="filter projects by commercial" role="button" tabindex="0" @click="changeFilter('commercial')" @keydown.enter.self="changeFilter('commercial')" :class="{'underline': filter == 'commercial'}" class="cursor-pointer">Commercial</div>
            <div aria-label="filter projects by personal" role="button" tabindex="0" @click="changeFilter('personal')" @keydown.enter.self="changeFilter('personal')" :class="{'underline': filter == 'personal'}" class="cursor-pointer">Personal</div>
            <div aria-label="show all projects" role="button" tabindex="0" @click="changeFilter(null)" @keydown.enter.self="changeFilter(null)" :class="{'underline': filter == null}" class="cursor-pointer">All</div>
      </div>
      <div class="grid grid-cols-2 content-start md:grid-cols-4 xl:grid-cols-6 gap-0">
        <router-link
          v-for="project in projects.data"
          :key="project.uid"
          :to="{ name: 'project', params: { id: project.uid } }"
          class="group relative overflow-hidden aspect-index"
          :class="{'opacity-20 pointer-events-none': checkFilter(project.category) }"
        >
          <div class="w-full h-full overflow-hidden" :style="`--custom:${randomInteger(5, 20)}deg`">
                  <img v-if="project.image.orientation == 'landscape'" class="w-full h-full object-cover transform transition-all duration-300 md:group-hover:scale-150 md:group-hover:rotate-custom" v-lazy="{
                    src: project.image.thumb,
                    loading: project.image.thumb,
                    error: project.image.thumb,
                  }" sizes="40vw" :data-srcset="project.image.lset" :alt="project.title">
                  <img v-else class="w-full h-full object-cover transform transition-all duration-300 md:group-hover:scale-150 md:group-hover:rotate-custom" v-lazy="{
                    src: project.image.thumb,
                    loading: project.image.thumb,
                    error: project.image.thumb,
                  }" sizes="40vw" :data-srcset="project.image.srcset" :alt="project.title">
          </div>    
          <div class="text-sm absolute md:text-lg bottom-0 md:bottom-auto md:top-1/2 left-1/2 z-30 p-4 w-full text-center transform -translate-x-1/2 md:-translate-y-1/2 transition-opacity duration-300 md:opacity-0 md:group-hover:opacity-100" v-html="project.title"></div>
        </router-link>
      </div>
    <div v-if="busy" class="p-4 text-center">Loading more</div>
  </main>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "projects",
  metaInfo: {
    title: "– Projects",
  },
  data() {
    return {
      busy: false,
      filter: null,
    };
  },
  computed: { 
      ...mapState(["projects"]),
      filtered() {
            return (this.filter) ? this.projects.data.filter(item => item.category == this.filter) : this.projects.data;
      }
    },
  methods: {
    changeFilter(filter) {
        if(filter !== this.filter) {
                this.filter = filter
        } else {
                this.filter = null;
        }
    },
    randomInteger(min, max) {
        let deg =  Math.floor(Math.random() * (max - min + 1)) + min;
        let plusOrMinus = Math.random() < 0.5 ? -1 : 1;
        return plusOrMinus * deg;
    },
    checkFilter(cat) {
        if(this.filter == null) {
                return false;
        } else {
                if(cat == this.filter) {
                    return false;
                } else {
                    return true;
                }
        }
    },
    loadMore() {
        this.busy = true;
        let curPage = this.projects.pagination.page;
        if (curPage < this.projects.pagination.pages) {
            this.$store.dispatch("loadProjects", curPage + 1).then(() => {
                this.busy = false;
            });
        } else {
            this.busy = false;
        }
    },
  },
};
</script>

